import React, { useState } from 'react';
import IntlMessages from 'Util/IntlMessages';
import VerificationForm from '../../../common/VerificationForm';
import icArrow1 from 'Assets/img/ic_arrow_right_16.png';
import icArrow2 from 'Assets/img/ic_arrow_right_16@2x.png';
import icArrow3 from 'Assets/img/ic_arrow_right_16@3x.png';
import { getImageSet } from 'Util/DataUtils';
import { VERIFY_TYPE } from 'Routes/sign-in/components/LeftSide/constants';
import IndividualJoinForm from '../../../common/IndividualJoinForm';

const icArrow = getImageSet([icArrow1, icArrow2, icArrow3]);

const STEP = {
  VERIFY: 1,
  JOIN: 2,
};

const JoinSection = ({ onChangeLogin, onCompleted }) => {
  const [step, setStep] = useState(STEP.VERIFY);
  const [phone, setPhone] = useState('');
  const [otpCode, setOtpCode] = useState('');
  const handleBack = () => {
    if (step === STEP.VERIFY) {
      onChangeLogin();
    } else {
      setStep(STEP.VERIFY);
    }
  };

  const handleGoToNext = ({ phone, otpCode }) => {
    setStep(STEP.JOIN);
    setPhone(phone);
    setOtpCode(otpCode);
  };

  return (
    <div className='inner-container'>
      <div
        className='cursor-pointer no-drag'
        style={{ backgroundColor: '#EEEEEE', borderRadius: '8px', width: '30px', height: '30px', minHeight: '30px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        onClick={handleBack}
      >
        <img {...icArrow} alt='ic-arrow' style={{ transform: 'rotate(180deg)' }} />
      </div>
      <div className='title-container'>
        <div className='title-main no-drag'>{step === STEP.VERIFY ? <IntlMessages id='signIn.join.phone.verify' /> : <IntlMessages id='sign.join' />}</div>
        <div className='title-sub'>{step === STEP.VERIFY ? <IntlMessages id='signIn.join.phone.message' /> : <IntlMessages id='signIn.join.subtitle' />}</div>
      </div>
      {step === STEP.VERIFY && <VerificationForm type={VERIFY_TYPE.SIGN_UP} goToNext={handleGoToNext} />}
      {step === STEP.JOIN && <IndividualJoinForm onCompleted={onCompleted} managerPhone={phone} otpCode={otpCode} />}
      <div className='join-text-wrapper' onClick={onChangeLogin}>
        <IntlMessages id='signIn.join.3' />{' '}
        <span className='join-text-blue'>
          <IntlMessages id='signIn.join.4' />
        </span>
      </div>
    </div>
  );
};

export default JoinSection;
